import theme from './bioBridge'

export default () => `
  body {
    margin: 0;
  }
  .ant-table-thead th.ant-table-cell {
    color: ${theme.brandPrimary} !important;
    font-weight: 500 !important;
  }
  .ant-typography[class*="title"],
  .primary-text,
  .ant-divider-inner-text {
    color: ${theme.brandPrimary};
  }

  .ant-form-item label {
    overflow: visible;
    white-space: normal;
    vertical-align: top;
  }

  .form-items-wrapper ant-form-item-additional {
    min-height: 0 !important;
  }

  .form-items-wrapper .ant-form-item {
    margin-bottom: 0 !important;
  }
`
